// extracted by mini-css-extract-plugin
export var container = "parking-detail-info-table-module--container--2b75f";